import { useAppStateDispatch } from '@src/providers/AppStateProvider/AppStateProviderHooks';
import { useEffect } from 'react';
import { OrgConfigurationKey, useOrgConfiguration } from '../OrgConfigurationProvider';
import { setCoinMetricsApiKey } from './coinMetricsCredentialsSlice';

/**
 * Syncs the ui.CoinMetricsApiKey org config value into the Redux coinMetricsCredentials slice.
 *
 * Must be rendered inside both:
 *   - AppStateProvider  (needs Redux dispatch)
 *   - OrgConfigurationProvider  (needs getConfig — provided via App.tsx wrapping)
 *
 * Pattern mirrors BlockedSubscriptionsSyncer.ts.
 */
export function CoinMetricsCredentialsSyncer() {
  const dispatch = useAppStateDispatch();
  const { getConfig } = useOrgConfiguration();

  const apiKey = getConfig(OrgConfigurationKey.CoinMetricsApiKey, '');

  useEffect(() => {
    dispatch(setCoinMetricsApiKey(apiKey || null));
  }, [apiKey, dispatch]);

  return null;
}
